import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Button } from 'react-bootstrap';
import { Field, reduxForm, formValueSelector, SubmissionError } from 'redux-form';
import { AsyncCreatable } from 'react-select';
import { EditorState, convertFromRaw } from 'draft-js';
import { convertToHTML } from 'draft-convert';
import { connect } from 'react-redux';
import { browserHistory, withRouter } from 'react-router';
import classnames from 'classnames';
import 'react-select/dist/react-select.css';
import BasicFormInput from '../../form/BasicFormInput';
import FormSelect from '../../form/FormSelect';
import FormDateTime from '../../form/FormDateTime';
import FormTextArea from '../../form/FormTextArea';
import { CONVERT_HTML_OPTIONS, ESPORT_TYPE_OPTIONS, BLITZ_ENTRY_TYPE_OPTIONS } from '../../form/constants';
import { generateEntrySlug, normalizeQuotes, formatTopImage } from '../../form/utils';
import BlitzAPI from '../../../api/BlitzAPI';
import RebrandlyAPI from '../../../api/RebrandlyAPI';
import { getUserOptions, getSourceOptions } from '../../../utils';
import FileToUrl from '../../form/FileToUrl';
import TwitterField from './TwitterField';
import TwitterPublished from './TwitterPublished';
import FacebookPublished from './FacebookPublished';
import PublishingField from './PublishingField';
import PublishSchedule from './PublishSchedule';
import BlitzEditor from '../../form/editor/BlitzEditor';
import SpinLoader from '../../form/SpinLoader';


const getTagOptions = (input) => {
  return BlitzAPI.getTags({ name: input }).then(
    (resp) => {
      return resp.data.data.map((tag) => {
        return { value: tag.id, label: tag.name };
      });
    },
  ).then((data) => { return { options: data }; });
};

function validate(values) {
  const errors = {};
  if (values.twitter_publish) {
    errors.twitter_message = values.twitter_message ? undefined : 'Twitter is Enabled. Require Twitter Message';
  }
  if (values.fb_publish) {
    errors.fb_message = values.fb_message ? undefined : 'Facebook is Enabled. Require Facebook Message';
  }
  errors.title = values.title ? undefined : 'Required';
  return errors;
}

function onSubmitFail(errors) {
  const value = JSON.stringify(errors, null, 2);
  alert(value);
}

class BlitzEntryForm extends Component {
  constructor(props) {
    super(props);
    const tags = props.tags && props.tags.map(
      (tag) => { return { label: tag.name, value: tag.id }; },
    );
    const { router } = this.props;
    this.state = {
      step: Number(router.location.query.step) === 2 ? 2 : 1,
      sources: 11,
      useEditor: false,
      showOutput: false,
      type: 'article',
      authors: null,
      tags,
      loadRebrandly: false,
      loadParseUrl: false,
    };
    this.onDeleteClick = this.onDeleteClick.bind(this);
    this.onEditorDataChange = this.onEditorDataChange.bind(this);
    this.toggleEditorButton = this.toggleEditorButton.bind(this);
    this.toggleOutputButton = this.toggleOutputButton.bind(this);
    this.createTag = this.createTag.bind(this);
    this.copy = this.copy.bind(this);
    this.setStep = this.setStep.bind(this);
    this.routerWillLeave = this.routerWillLeave.bind(this);
    // console.log("---------init", props.initialValues);
    // console.log("---------entry", props.entry);
    // console.log("---------", Object.is(props.initialValues, props.entry));
    // if (!Object.is(props.initialValues, props.entry)) {
    //
    // }
    // console.log("initialize shit!!!!")
  }
  componentDidMount() {
    const { router, routes } = this.props;
    router.setRouteLeaveHook(routes[1], this.routerWillLeave);

    BlitzAPI.getSources().then(
      (response) => {
        const sourceOptions = getSourceOptions(response);
        this.setState(
          {
            sources: sourceOptions,
          },
        );
      },
    );
    BlitzAPI.getUsers().then(
      (response) => {
        const userOptions = getUserOptions(response);
        this.setState(
          {
            authors: userOptions,
          },
        );
      },
    );
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.tags !== nextProps.tags) {
      const tags = (nextProps.tags && nextProps.tags.map(
        (tag) => { return { label: tag.name, value: tag.id }; },
      )) || [];
      this.setState({ tags });
    }
  }

  onDeleteClick() {
    const { entry_id } = this.props;

    if (confirm('Delete this entry?')) {
      BlitzAPI.deleteEntry(entry_id).then(
        () => browserHistory.push('/entries/blitz'),
      );
    }
  }

  onEditorDataChange(event, newValue, previousValue) {
    const { change } = this.props;
    const editorState = EditorState.createWithContent(convertFromRaw(newValue));
    const contentState = editorState.getCurrentContent();
    const html = convertToHTML(CONVERT_HTML_OPTIONS)(contentState);

    change('content', html);
  }

  createTag(val) {
    const { entry_id } = this.props;
    const { tags } = this.state;
    if (tags && tags.length > val.length) {
      const deleted = tags.filter(x => !(new Set(val).has(x)))[0];
      BlitzAPI.deleteEntryTag({ entry_id, tag_id: deleted.value });
    } else {
      const newItem = val.filter(x => !(new Set(tags).has(x)))[0];
      if (!Number.isInteger(newItem.value)) {
        BlitzAPI.postTag({ tag: { name: newItem.label } }).then(resp => BlitzAPI.postEntryTag(
          { entry_id, tag_id: resp.data.data.id },
        ));
      } else {
        BlitzAPI.postEntryTag({ entry_id, tag_id: newItem.value });
      }
    }

    this.setState({ tags: val });
  }

  toggleEditorButton() {
    const { useEditor } = this.state;
    this.setState({ useEditor: !useEditor });
  }

  toggleOutputButton() {
    const { showOutput } = this.state;
    this.setState({ showOutput: !showOutput });
  }

  copy(time) {
    const { change } = this.props;
    change('publish_date', time);
    change('twitter_publish_date', time);
    change('fb_publish_date', time);
  }

  generateLink(resp, slashtag, title) {
    this.setState({ loadRebrandly: true });
    return RebrandlyAPI.postLinks(
      {
        destination: generateEntrySlug(resp.data.data, false, true),
        domain: { fullName: 'blitz.gg' },
        slashtag,
        title,
      },
    ).then((response) => {
      this.setState({ loadRebrandly: false });
      this.props.change('short_url', response.data.shortUrl);
    }).catch(() => {
      this.setState({ loadRebrandly: false });
      throw new SubmissionError({
        slash_tag: 'Tag Taken. Try another one.',
      });
    });
  }

  routerWillLeave() {
    const { useEditor } = this.state;
    if (useEditor) {
      return 'Are you sure you want to leave without saving?';
    }
  }

  setStep(index) {
    window.scrollTo(0, 0);
    this.setState({
      step: index,
    });
  }

  render() {
    const {
      handleSubmit, onSubmit, submitting, published, type, entry_id,
      change, top_image, cover_image, title, slash_tag,
      twitter_publish, twitter_publish_date,
      fb_publish, fb_publish_date, fb_link, fb_message,
      twitter_message, twitter_image_url, twitter_id, fb_id,
    } = this.props;
    const { tags, sources, authors, useEditor, loadRebrandly, loadParseUrl, step } = this.state;
    if (!(sources && authors)) {
      return <h1>Loading</h1>;
    }
    if (useEditor) {
      return (<BlitzEditor
        toggleEditorButton={this.toggleEditorButton}
        save={
          handleSubmit(v => onSubmit(v).then(
            resp => browserHistory.push(`/entries/blitz/${resp.data.data.id}`),
          ))
        }
        preview={handleSubmit(v => onSubmit(v).then((r) => {
          window.open(generateEntrySlug(r.data.data, false, true));
          return r;
        }).then(
          r => browserHistory.replace(`/entries/blitz/${r.data.data.id}`),
        ))}
      />);
    }
    return (
      <form
        onSubmit={
          handleSubmit(v => onSubmit(Object.assign(v, { published: true })).then(() => browserHistory.push('/entries/blitz')))
        }
        className="create-form-blitz"
      >
        <div className={`create-form-blitz-content ${this.props.entry_id ? 'create-form-blitz-content-edit' : ''}`}>
          <div className="create-form-blitz-step clearfix">
            <div
              className={classnames(
              'create-form-blitz-step-item', `${step === 1 ? 'create-form-blitz-step-active' : null}`,
            )} onClick={() => this.setStep(1)}
            >Step 1: Edit
            </div>
            <div
              className={classnames(
              'create-form-blitz-step-item', `${step === 2 ? 'create-form-blitz-step-active' : null}`,
            )} onClick={() => this.setStep(2)}
            >Step 2: Publish
            </div>
          </div>
          {step === 1 ?
          <div className="create-form-blitz-step1">
            <div className="form-section">
              {type === 'youtube' &&
                <div className="form-section">
                  <div className="form-section-header">
                    <h4 className="form-section-title">Import from YouTube</h4>
                    <h6 className="form-section-caption">Enter the YouTube URL to import metadata from a YouTube link.</h6>
                  </div>
                  <Field
                    type="url"
                    name="url"
                    placeholder="Entry URL"
                    component={BasicFormInput}
                    controlId="entryURL"
                    label="Entry URL"
                  />
                  <Button
                    className="button-primary create-form-button-editor clearfix"
                    type="button"
                    disabled={this.props.loadParseUrl}
                    onClick={() => this.props.parseEntryFromUrl(this.props.url)}
                  >Parse from URL</Button>
                  {loadParseUrl && <SpinLoader />}
                </div>
              }
              <Field
                type="text"
                name="title"
                placeholder="Title"
                component={BasicFormInput}
                controlId="entryTitle"
                label="Entry Title"
                normalize={normalizeQuotes}
              />
              <Field
                name="description"
                component={FormTextArea}
                label="Description"
                normalize={normalizeQuotes}
              />
              <Field
                name="share_description"
                component={FormTextArea}
                label="Share Description (FB/Twitter) (Optional)"
                normalize={normalizeQuotes}
              />
            </div>
            <div className="form-section create-form-editor">
              <div className="form-section-header">
                <h4 className="form-section-title">Start Writing</h4>
                <h6 className="form-section-caption">
                  Click the button below to write or edit your content.
                </h6>
              </div>

              <Button className="button-primary create-form-button-editor clearfix" onClick={this.toggleEditorButton} type="button">
                <div className="button-caption">Open Editor</div>
                <div className="button-icon">
                  <img className="fit-parent" src="/assets/img/icons/open_editor.png" alt="editor button" />
                </div>
              </Button>
            </div>
            <div className="form-section create-form-image">
              <div className="form-section-header">
                <h4 className="form-section-title">Set Cover Image</h4>
                <h6 className="form-section-caption">Upload a cover image or paste an image URL.</h6>
              </div>
              <div className="create-form-image-content clearfix">
                <div className="create-form-image-item clearfix">
                  <Field
                    label="Cover Image"
                    name="cover_image"
                    component={BasicFormInput}
                    controlId="coverImage"
                    format={formatTopImage}
                  />
                  <FileToUrl onUrlChange={newUrl => change('cover_image', newUrl)} />
                  {formatTopImage(cover_image) && <img className="create-form-image-thumbnail" src={formatTopImage(cover_image)} role="presentation" />}
                </div>
                <div className="create-form-image-item clearfix">
                  <Field
                    label="Share Image - For FB/Twitter Previews"
                    name="top_image"
                    component={BasicFormInput}
                    controlId="topImage"
                    format={formatTopImage}
                  />
                  <FileToUrl onUrlChange={newUrl => change('top_image', newUrl)} />
                  {formatTopImage(top_image) && <img className="create-form-image-thumbnail" src={formatTopImage(top_image)} role="presentation" />}
                </div>
              </div>
            </div>
            <div className="form-section">
              <div className="form-section-header">
                <h4 className="form-section-title">Metadata</h4>
              </div>
              <div className="form-section-content">
                <div className="form-section-content-row form-section-metadata-row clearfix">
                  <Field
                    label="Author"
                    name="author_id"
                    component={FormSelect}
                    options={authors}
                  />
                  <Field
                    label="Esport"
                    name="esport"
                    component={FormSelect}
                    options={ESPORT_TYPE_OPTIONS}
                  />
                  <Field
                    label="Type"
                    name="type"
                    component={FormSelect}
                    options={BLITZ_ENTRY_TYPE_OPTIONS}
                  />
                </div>
                <div className="form-section-content-row form-section-metadata-row clearfix">
                  <Field
                    type="text"
                    name="related_match"
                    component={BasicFormInput}
                    controlId="relatedMatch"
                    label="Related Match ID"
                  />
                  <Field
                    type="text"
                    name="related_tournament"
                    component={BasicFormInput}
                    controlId="relatedTournament"
                    label="Related Tournament ID"
                  />
                </div>
              </div>
            </div>
          </div>
          : null}
          {step === 2 ?
          <div className="create-form-blitz-step2">
            <div className="form-section form-section-finishing-touch">
              <div className="form-section-header clearfix">
                <h4 className="form-section-title">Finishing Touch</h4>
              </div>
              <div className="form-section-content clearfix">
                {entry_id ?
                <div className="form-tag">
                  <label className="control-label">Tags</label>
                  <AsyncCreatable
                    loadOptions={getTagOptions}
                    ignoreCase={false}
                    onChange={this.createTag}
                    value={tags}
                    multi
                  />
                </div>
                : null}
                <div className="form-custom-link clearfix">
                  <div className="form-custom-link-content clearfix">
                    <Field
                      type="text"
                      name="slash_tag"
                      placeholder="short-url (optional)"
                      component={BasicFormInput}
                      controlId="entrySlashTag"
                      label="Rebrandly URL Shortener"
                    />
                    <Button
                      className="button-secondary form-custom-link-action"
                      disabled={loadRebrandly}
                      onClick={
                        handleSubmit(
                          v => onSubmit(v).then((resp) => {
                            this.generateLink(resp, slash_tag, title);
                            return resp;
                          }).then(
                            resp => browserHistory.push(`/entries/blitz/${resp.data.data.id}?step=2`),
                          ),
                        )
                      }
                      type="button"
                    >
                      <div className="button-caption">Generate Link</div>
                    </Button>
                    {loadRebrandly && <SpinLoader style={{ marginTop: '38px' }} />}
                  </div>
                  <Field
                    type="url"
                    name="short_url"
                    readOnly
                    component={BasicFormInput}
                    controlId="entryShortURL"
                  />
                </div>
                <div className="form-publish-date clearfix">
                  <div className="form-publish-date clearfix">
                    <Field
                      label="Publish Date"
                      name="publish_date"
                      component={FormDateTime}
                      format={value => value && moment(value)}
                      controlId="entryPublishDate"
                    />
                  </div>
                </div>
                <div className="form-show-rss">
                  <Field
                    type="checkbox"
                    name="show_rss"
                    placeholder="Show on RSS Feed"
                    component={BasicFormInput}
                    controlId="show_rss"
                    label="Show on RSS"
                    normalize={v => !!v}
                  />
                </div>
                <hr />
                {type === 'youtube' && <div className="form-show-rss">
                  <Field
                    type="checkbox"
                    name="yt_publish"
                    normalize={v => !!v}
                    placeholder="Re-List on Youtube"
                    component={BasicFormInput}
                    controlId="show_youtube"
                    label="Automatically Publish Video on Youtube - This will run 3 minutes after the publish date so Corylulu can post to Reddit."
                  />
                </div>}
              </div>
            </div>
            {/* IF PUBLISHED ADD CLASS "form-section-published" */}
            <div className="form-section form-section-website clearfix">
              <div className="form-section-header clearfix">
                <h4 className="form-section-title">Website</h4>
                <div className="form-section-published-state clearfix">
                  <div className="form-section-published-icon">
                    <img className="fit-parent" src="/assets/img/icons/check.png" role="presentation" />
                  </div>
                  <div className="form-section-published-caption">Published</div>
                </div>
              </div>
              <PublishingField {...this.props} dateFieldName="publish_date" publishFieldName="show_web" copy={this.copy} />
            </div>

            <div className="form-section form-section-app clearfix">
              <div className="form-section-header clearfix">
                <h4 className="form-section-title">App</h4>
                <div className="form-section-published-state clearfix">
                  <div className="form-section-published-icon">
                    <img className="fit-parent" src="/assets/img/icons/check.png" role="presentation" />
                  </div>
                  <div className="form-section-published-caption">Published</div>
                </div>
              </div>
              <PublishingField {...this.props} dateFieldName="publish_date" publishFieldName="show_mobile" copy={this.copy} />
            </div>

            <div className="form-section form-section-twitter clearfix">
              <div className="form-section-header clearfix">
                <h4 className="form-section-title">Twitter</h4>
                {/* <div className="form-section-published-state clearfix">
                  <div className="form-section-published-icon"><img className="fit-parent" src="/assets/img/icons/check.png" /></div>
                  <div className="form-section-published-caption">Published</div>
                </div> */}
              </div>
              <h6 className="form-section-caption">
                Auto Tweet this entry at the Publish Time.
              </h6>
              <br />
              { twitter_id ?
                <TwitterPublished image={twitter_image_url} date={twitter_publish_date} message={twitter_message} />
                :
                <div>
                  <PublishingField {...this.props} dateFieldName="twitter_publish_date" publishFieldName="twitter_publish" copy={this.copy} />
                  {/* <Field component={BasicFormInput} required={twitter_publish} label="Share Description" /> */}
                  <TwitterField formatTopImage={formatTopImage} {...this.props} twitter_publish={twitter_publish} />
                  <br />
                  <h6 className="form-section-caption">
                    [Optional] The image that should be shared on Twitter. URL's should go directly in the tweet.
                  </h6>
                </div>
              }
            </div>

            <div className="form-section form-section-facebook clearfix">
              <div className="form-section-header clearfix">
                <h4 className="form-section-title">Facebook</h4>
                {/* <div className="form-section-published-state clearfix">
                  <div className="form-section-published-icon"><img className="fit-parent" src="/assets/img/icons/check.png" /></div>
                  <div className="form-section-published-caption">Published</div>
                </div> */}
              </div>
              <h6 className="form-section-caption">
                Auto Post this entry to Facebook at the Publish Time.
              </h6>
              <br />
              {fb_id ?
                <FacebookPublished date={fb_publish_date} message={fb_message} link={fb_link} />
                :
                <div>
                  <PublishingField {...this.props} dateFieldName="fb_publish_date" publishFieldName="fb_publish" copy={this.copy} />
                  {/* <Field component={BasicFormInput} required={fb_publish} label="Share Description" /> */}
                  <Field name="fb_message" component={FormTextArea} required={fb_publish} label="Message" />
                  <Field name="fb_link" component={BasicFormInput} label="Link" />
                  <h6 className="form-section-caption">
                    [Optional] The link that should be previewed on the facebook post. Paste a URL here.
                  </h6>
                </div>
              }

            </div>
          </div>
          : null}
        </div>
        <div className="create-entry-sidebar">
          <div className="create-entry-action">
            {/* If Future time, add class "create-entry-schedule-action" instead of "create-entry-publish" */}
            {step === 2 ?
              <Button
                type="submit"
                className="button-primary button-full create-entry-publish"
                disabled={submitting}
              >
                {/* If Future time, set icon to "schedule_light.png" instead of "publish.png" */}
                <div className="button-icon">
                  <img className="fit-parent" src="/assets/img/icons/publish.png" role="presentation" />
                </div>
                {/* If Future time, set caption to Schedule instead of Publish */}
                <div className="button-caption">Publish</div>
              </Button>
              :
                <div
                  className="button-primary button-full create-entry-next" onClick={() => this.setStep(2)}
                >
                  <div className="button-caption">Next Step</div>
                  <div className="button-icon">
                    <img className="fit-parent" src="/assets/img/icons/arrow_right.png" role="presentation" />
                  </div>
                </div>
            }
            <Button
              className="button-secondary button-full create-entry-draft"
              onClick={
                handleSubmit(
                  v => onSubmit(Object.assign(v, { published: false })).then(() => browserHistory.push('/entries/blitz')),
                )
              }
              disabled={submitting}
            >{published ? 'Unpublish' : 'Save as Draft'}</Button>
            <Button
              disabled={submitting}
              onClick={
                handleSubmit(
                  v => onSubmit(v).then((r) => {
                    window.open(generateEntrySlug(r.data.data, false, true));
                    return r;
                  }).then(r => browserHistory.push(`/entries/blitz/${r.data.data.id}`)),
                )
              }
              className="button-secondary button-full create-entry-preview"
            >Preview</Button>
            {entry_id ?
              <Button
                type="button"
                onClick={this.onDeleteClick}
                className="button-secondary button-full create-entry-delete"
                bsStyle="danger"
              >Delete</Button> : null}
          </div>
          <PublishSchedule />
        </div>
      </form>
    );
  }
}

const selector = formValueSelector('generic-entry');
function mapStateToProps(state) {
  return {
    entry_id: selector(state, 'id'),
    tags: selector(state, 'tags'),
    type: selector(state, 'type') || 'article',
    published: selector(state, 'published'),
    cover_image: selector(state, 'cover_image'),
    top_image: selector(state, 'top_image'),
    title: selector(state, 'title'),
    slash_tag: selector(state, 'slash_tag'),
    url: selector(state, 'url'),
    twitter_image_url: selector(state, 'twitter_image_url'),
    twitter_message: selector(state, 'twitter_message'),
    twitter_publish: selector(state, 'twitter_publish'),
    twitter_publish_date: selector(state, 'twitter_publish_date'),
    fb_publish: selector(state, 'fb_publish'),
    fb_publish_date: selector(state, 'fb_publish_date'),
    twitter_id: selector(state, 'twitter_id'),
    fb_message: selector(state, 'fb_message'),
    fb_id: selector(state, 'fb_id'),
    fb_link: selector(state, 'fb_link'),
  };
}


BlitzEntryForm = connect(
  mapStateToProps,
)(reduxForm({
  form: 'generic-entry',
  validate,
  enableReinitialize: true,
  destroyOnUnmount: false,
  onSubmitFail,
})(BlitzEntryForm));

BlitzEntryForm.propTypes = {
  handleSubmit: PropTypes.func,
  onSubmit: PropTypes.func,
  entry_id: PropTypes.number,
  change: PropTypes.func,
  tags: PropTypes.array,
  url: PropTypes.string,
  type: PropTypes.string,
  submitting: PropTypes.bool,
  published: PropTypes.bool,
  router: PropTypes.object,
  routes: PropTypes.array,
  loadParseUrl: PropTypes.bool,
  parseEntryFromUrl: PropTypes.func,
};

export default withRouter(BlitzEntryForm);



// WEBPACK FOOTER //
// ./src/cms/entry/blitz/BlitzEntryForm.js